/* eslint-disable no-unused-vars */
import { Delete } from "@mui/icons-material";
import { createContext } from "react";

export const StoreContext = createContext({
  isAdmin: false,

  schools: [],
  schoolOptions: [],

  studentSchools: [],
  studentSchoolOptions: [],

  personelSchools: [],
  personelSchoolOptions: [],

  students: [],
  studentOptions: [],
  studentToParentMap: {},

  users: [],
  userMap: {},

  automations: [],
  automationOptions: [],
  companies: [],
  companyOptions: [],

  vehicles: [],
  drivers: [],
  driverOptions: [],
  vehicleOptions: [],
  vehicleRoutes: [],
  bundledRoutes: [],

  stopOptions: [],

  parentOptions: [],
  personelOptions: [],
  relations: [],
  storeReady: false,
  isProcessing: false,
  contracts: [],
  educationYears: [],
  discounts: [],
  serviceTemplates: [],
  educationYearsOptions: [],
  discountOptions: [],
  serviceTemplateOptions: [],
  receipts: [],
  withdraws: [],
  contractsOptions: [],
  expenses: [],
  vehicleRouteOptions: [],
  vehiclePayments: [],
  transfers: [],
  transferregions: [],
  transferregionOptions: [],

  shifts: [],
  stops: [],
  userOptions: [],
  shiftOptions: [],
  shiftUsers: [],
  shiftUserOptions: [],
  // Personel Services
  standartPersonelServices: [],
  standartPersonelServiceOptions: [],
  shiftPersonelServices: [],
  shiftPersonelServiceOptions: [],
  driverDetails: [],
  attendants: [],
  attendantOptions: [],
  custodies: [],
  // Remove custodyOptions
  accidents: [],
  maintenances: [],
  thirdParties: [],

  selectedEducationYearId: null,
  UpdateSelectedEducationYearId: (educationYearId) => {},

  // Functions
  UpdateVehicles: () => {},
  UpdateVehicleRoutes: async () => {},
  InsertVehicleRoute: (vehicleRoute) => {},
  UpdateVehicleRoute: (vehicleRoute) => {},
  DeleteVehicleRoute: (vehicleRouteId) => {},
  UpdateBundledRoutes: async () => {},
  InsertBundledRoute: (bundledRoute) => {},
  UpdateBundledRoute: (bundledRoute) => {},
  DeleteBundledRoute: (bundledRouteId) => {},
  InsertExpense: (expense) => {},
  UpdateExpense: (expense) => {},
  DeleteExpense: (expenseId) => {},
  UpdateCompanies: () => {},
  UpdateSchools: () => {},
  InsertSchool: (school) => {},
  UpdateSchool: (school) => {},
  DeleteSchool: (schoolId) => {},
  UpdateRelations: async () => {},
  UpdateUsers: () => {},
  InsertUser: (user) => {},
  UpdateUser: (user) => {},
  DeleteUser: (userId) => {},
  InsertStudent: (student) => {},
  UpdateStudent: (student) => {},
  DeleteStudent: (studentId) => {},
  InsertRelation: (relation) => {},
  UpdateRelation: (relation) => {},
  DeleteRelation: (relationId) => {},
  UpdatePersonelServices: async () => {},
  InsertPersonelService: (service) => {},
  UpdatePersonelService: (service) => {},
  DeletePersonelService: (serviceId) => {},
  InsertShift: (shift) => {},
  UpdateShift: (shift) => {},
  DeleteShift: (shiftId) => {},
  InsertStop: (stop) => {},
  UpdateStop: (stop) => {},
  DeleteStop: (stopId) => {},
  UpdateTransfers: async () => {},
  UpdateStudents: async () => {},
  UpdateEverything: async () => {},
  RetrieveContracts: async () => {},
  InsertContract: (contract) => {},
  UpdateContract: (contract) => {},
  DeleteContract: (contractId) => {},
  RetrieveReceipts: async () => {},
  RetrieveWithdraws: async () => {},
  RetrieveAccountingUtils: async () => {},
  RetrieveExpenses: async () => {},
  UpdateVehiclePayments: async () => {},
  UpdateTransferregions: async () => {},
  UpdateShifts: async () => {},
  UpdateStops: async () => {},
  GetParentFromStudent: (studentId) => {},
  UpdateDrivers: async () => {},
  InsertDriver: (driver) => {},
  UpdateDriver: (driver) => {},
  DeleteDriver: (driverId) => {},
  RetrieveEducationYears: async () => {},
  RetrieveAutomations: async () => {},
  UpdateAutomation: (automation) => {},
  InsertAutomation: (automation) => {},
  DeleteAutomation: (automationId) => {},
  InsertTransfer: (transfer) => {},
  UpdateTransfer: (transfer) => {},
  DeleteTransfer: (transferId) => {},
  InsertReceipt: (receipt) => {},
  UpdateReceipt: (receipt) => {},
  DeleteReceipt: (receiptId) => {},
  InsertServiceTemplate: (serviceTemplate) => {},
  UpdateServiceTemplate: (serviceTemplate) => {},
  DeleteServiceTemplate: (serviceTemplateId) => {},
  InsertDiscount: (discount) => {},
  UpdateDiscount: (discount) => {},
  DeleteDiscount: (discountId) => {},
  InsertEducationYear: (educationYear) => {},
  UpdateEducationYear: (educationYear) => {},
  DeleteEducationYear: (educationYearId) => {},
  InsertWithdraw: (withdraw) => {},
  UpdateWithdraw: (withdraw) => {},
  DeleteWithdraw: (withdrawId) => {},
  InsertVehiclePayment: (vehiclePayment) => {},
  UpdateVehiclePayment: (vehiclePayment) => {},
  DeleteVehiclePayment: (vehiclePaymentId) => {},
  InsertTransferRegion: (transferRegion) => {},
  UpdateTransferRegion: (transferRegion) => {},
  DeleteTransferRegion: (transferRegionId) => {},
  InsertVehicle: (vehicle) => {},
  UpdateVehicle: (vehicle) => {},
  DeleteVehicle: (vehicleId) => {},

  RetrieveDriverDetails: async () => {},
  InsertDriverDetail: (driverDetail) => {},
  UpdateDriverDetail: (driverDetail) => {},
  DeleteDriverDetail: (driverDetailId) => {},

  RetrieveAttendants: async () => {},
  InsertAttendant: (attendant) => {},
  UpdateAttendant: (attendant) => {},
  DeleteAttendant: (attendantId) => {},

  RetrieveCustodies: async () => {},
  InsertCustody: (custody) => {},
  UpdateCustody: (custody) => {},
  DeleteCustody: (custodyId) => {},

  RetrieveAccidents: async () => {},
  InsertAccident: (accident) => {},
  UpdateAccident: (accident) => {},
  DeleteAccident: (accidentId) => {},
  RetrieveMaintenances: async () => {},
  InsertMaintenance: (maintenance) => {},
  UpdateMaintenance: (maintenance) => {},
  DeleteMaintenance: (maintenanceId) => {},
  RetrieveThirdParties: async () => {},
  InsertThirdParty: (thirdParty) => {},
  UpdateThirdParty: (thirdParty) => {},
  DeleteThirdParty: (thirdPartyId) => {},

  fuels: [],
  RetrieveFuels: async () => {},
  InsertFuel: (fuel) => {},
  UpdateFuel: (fuel) => {},
  DeleteFuel: (fuelId) => {},

  stocks: [],
  stockOptions: [],
  RetrieveStocks: async () => {},
  InsertStock: (stock) => {},
  UpdateStock: (stock) => {},
  DeleteStock: (stockId) => {},

  stockMovements: [],
  RetrieveStockMovements: async () => {},
  InsertStockMovement: (movement) => {},
  UpdateStockMovement: (movement) => {},
  DeleteStockMovement: (movementId) => {},
});
